import { FC } from 'react'
import { Draggable } from 'react-beautiful-dnd'
import { DragIndicator } from '@mui/icons-material'
import { Box, Chip, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'

import { ObjectFieldDTO } from '@types'

interface DraggableFieldItemProps {
  field: ObjectFieldDTO & { commandKey: string; commandName: string }
  index: number
}

export const DraggableFieldItem: FC<DraggableFieldItemProps> = ({ field, index }) => {
  const draggableId = `FIELD:${field.commandKey}:${field.name}`

  return (
    <Draggable draggableId={draggableId} index={index}>
      {(provided, snapshot) => (
        <Box
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          sx={{
            display: 'flex',
            alignItems: 'center',
            py: 1.5,
            px: 2,
            gap: 2,
            backgroundColor: snapshot.isDragging ? 'action.hover' : 'transparent',
            borderRadius: 1,
            cursor: 'grab',
            '&:hover': {
              backgroundColor: 'action.hover',
            },
            transition: 'background-color 0.2s',
          }}
        >
          <DragIndicator
            fontSize='small'
            sx={{
              color: grey[600],
            }}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
            <Typography
              variant='body2'
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontWeight: 500,
              }}
            >
              {field.name}
            </Typography>
            <Box sx={{ display: 'flex', gap: 0.5, mt: 0.5 }}>
              <Chip
                label={field.valueType}
                size='small'
                sx={{
                  height: 18,
                  fontSize: '0.65rem',
                  '& .MuiChip-label': { px: 0.75 },
                }}
              />
            </Box>
          </Box>
        </Box>
      )}
    </Draggable>
  )
}
